<template>
  <div>
    <CrudBase
      title="Grupos de Coordenadores"
      subtitle="Os grupos serão associados aos usuários para permitir a interação no chat."
      singular-title="Grupo"
      api-endpoint="/api/v1/coordinator_groups"
      resource-name="coordinator_group"
      :columns="columns"
      :form-fields="formFields"
      text-action-buttons
    >
      <template #form="{ form }">
        <div class="space-y-4">
          <div>
            <label for="cg_name" class="block text-sm font-medium text-slate-300 mb-1">
              Nome <span class="text-red-400">*</span>
            </label>
            <input
              id="cg_name"
              v-model="form.name"
              type="text"
              required
              class="w-full px-3 py-2 rounded-lg border border-slate-500/80 bg-slate-800/55 text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-cyan-400/40 focus:border-cyan-400/70"
            />
          </div>

          <div class="border-t border-slate-700/70 pt-4">
            <p class="text-sm font-medium text-slate-200 mb-2">
              Coordenadores do grupo <span class="text-red-400">*</span>
            </p>
            <p class="text-xs text-slate-400 mb-3">
              Obrigatório marcar pelo menos um. Eles respondem no chat dos usuários associados a este grupo.
            </p>
            <div v-if="coordinatorsLoading" class="text-sm text-slate-400 py-4">Carregando lista…</div>
            <div
              v-else-if="coordinatorAgents.length === 0"
              class="text-sm text-amber-200/90 bg-amber-500/10 border border-amber-400/30 rounded-lg px-3 py-2"
            >
              Nenhum coordenador cadastrado. Crie coordenadores em Agentes → Coordenadores.
            </div>
            <div v-else class="max-h-52 overflow-y-auto rounded-lg border border-slate-600/80 bg-slate-900/40 divide-y divide-slate-700/60">
              <label
                v-for="a in coordinatorAgents"
                :key="a.id"
                class="flex items-center gap-3 px-3 py-2.5 hover:bg-slate-800/50 cursor-pointer"
              >
                <input
                  type="checkbox"
                  class="rounded border-slate-500 text-cyan-500 focus:ring-cyan-400/50"
                  :checked="isCoordinatorSelected(form, a.id)"
                  @change="toggleCoordinator(form, a.id, $event.target.checked)"
                />
                <span class="text-sm text-slate-100">{{ a.name }}</span>
              </label>
            </div>
          </div>
        </div>
      </template>
    </CrudBase>
  </div>
</template>

<script>
import CrudBase from './CrudBase.vue'
import { useApi } from '../composables/useApi.js'

export default {
  components: { CrudBase },

  setup() {
    const { get } = useApi()
    return { apiGet: get }
  },

  data() {
    return {
      coordinatorsLoading: true,
      coordinatorAgents: [],
      columns: [
        { key: 'name', label: 'Nome' },
        { key: 'coordinators_summary', label: 'Coordenadores' }
      ],
      formFields: {
        name: '',
        coordinator_ids: []
      }
    }
  },

  mounted() {
    this.loadCoordinatorAgents()
  },

  methods: {
    async loadCoordinatorAgents() {
      this.coordinatorsLoading = true
      try {
        const { data, error } = await this.apiGet(
          '/api/v1/agents?agent_type=coordinator&items=200&page=1'
        )
        if (error || !data?.data) {
          this.coordinatorAgents = []
          return
        }
        this.coordinatorAgents = Array.isArray(data.data)
          ? data.data.map((a) => ({ id: a.id, name: a.name }))
          : []
      } finally {
        this.coordinatorsLoading = false
      }
    },

    isCoordinatorSelected(form, id) {
      const ids = Array.isArray(form.coordinator_ids) ? form.coordinator_ids : []
      return ids.includes(id)
    },

    toggleCoordinator(form, id, checked) {
      const cur = Array.isArray(form.coordinator_ids) ? [...form.coordinator_ids] : []
      const set = new Set(cur)
      if (checked) {
        set.add(id)
      } else {
        set.delete(id)
      }
      form.coordinator_ids = Array.from(set).sort((a, b) => a - b)
    }
  }
}
</script>
